jQuery(document).ready(function($) {
    "use strict";

    var $news = $('.single-post');

    var filters = {
        active: $.makeArray($('.js-category-filter').map(function() {
            return $(this).data('category');
        }))
    };

    $('.js-category-filter').on('click', onToggleFilter);

    function onToggleFilter(e) {
        e.preventDefault();

        var $this = $(this);
        var filter = $this.data('category');

        var index = filters.active.indexOf(filter);
        if(index > -1) {
            filters.active.splice(index, 1);
        } else {
            filters.active.push(filter);
        }

        applyFilters();
    }

    function applyFilters() {
        var $elements = [];

        for(var x = 0, l = $news.length, $post, categories, found; x < l; ++x) {
            $post = $($news[x]);
            categories = ($post.data('category') + "").split(',');

            found = false;
            for(var y = 0, ll = categories.length, category; y < ll; ++y) {
                category = +categories[y];
                if(filters.active.indexOf(category) > -1) {
                    found = true;
                    $post.show();
                    break;
                }
            }

            if(!found) {
                $post.hide();
            }
        }

        $('.js-category-filter').removeClass('check-disable');
        $('.js-category-filter').each(function() {
            var $this = $(this);
            var category = $this.data('category');
            if(filters.active.indexOf(category) === -1) {
                $this.addClass('check-disable');
            }
        });
    }
});